import type { Response } from 'express';

export function configHtmlCache(res?: Partial<Response>, ttl: number = 3600) {
    if (res && typeof res.set === 'function') {
        res.set('Cache-Control', `public, must-revalidate, max-age=${ttl}`);
        res.setHeader?.(
            'Accept-CH',
            'Sec-CH-Viewport-Width,Sec-CH-Downlink,Sec-CH-UA,Sec-CH-UA-Platform,Sec-CH-UA-Mobile',
        );
    }
}
